export const likedKeywords = [
  {
    id: 90,
    name: "paris, france",
    movies: [59436, 27205, 194],
  },
  {
    id: 588,
    name: "rome, italy",
    movies: [81836],
  },
  {
    id: 260373,
    name: "sistine chapel",
    movies: [551332],
  },
  {
    id: 716,
    name: "vatican",
    movies: [551332],
  },
  {
    id: 9672,
    name: "based on a true story",
    movies: [551332, 45269, 266856],
  },
  {
    id: 310,
    name: "artificial intelligence",
    movies: [17431, 152601, 157336],
  },
  {
    id: 5565,
    name: "biography",
    movies: [453, 266856],
  },
  {
    id: 2051,
    name: "intelligence",
    movies: [453],
  },
  {
    id: 4379,
    name: "time travel",
    movies: [59436, 329865],
  },
  {
    id: 212,
    name: "london, england",
    movies: [508, 509, 634, 9801],
  },
  {
    id: 5318,
    name: "seoul, south korea",
    movies: [496243],
  },
  {
    id: 1566,
    name: "dream",
    movies: [27205],
  },
  {
    id: 12670,
    name: "los angeles, california",
    movies: [27205, 114, 313369],
  },
  {
    id: 12436,
    name: "architecture",
    movies: [27205],
  },
  {
    id: 223540,
    name: "singularity",
    movies: [152601],
  },
  {
    id: 9673,
    name: "love",
    movies: [152601],
  },
  {
    id: 34265,
    name: "heartbreak",
    movies: [152601],
  },
  {
    id: 65,
    name: "holiday",
    movies: [634],
  },
  {
    id: 392,
    name: "england",
    movies: [634, 205596],
  },
  {
    id: 699,
    name: "love at first sight",
    movies: [508],
  },
  {
    id: 14641,
    name: "based on memoir or autobiography",
    movies: [266856],
  },
  {
    id: 242,
    name: "new york city",
    movies: [492188, 101],
  },
  {
    id: 1157,
    name: "husband wife relationship",
    movies: [492188, 266856],
  },
  {
    id: 9935,
    name: "travel",
    movies: [14160],
  },
  {
    id: 1416,
    name: "jazz",
    movies: [313369],
  },
  {
    id: 1691,
    name: "dance",
    movies: [313369],
  },
  {
    id: 33973,
    name: "glam rock",
    movies: [13403],
  },
  {
    id: 165606,
    name: "rock odyssey",
    movies: [13403],
  },
  {
    id: 8012,
    name: "physicist",
    movies: [266856],
  },
];
